import React, { useEffect, useState } from "react";
import "./LoanBankCodes.scss";
import { Box, Button, TextField, Typography } from "@mui/material";
import { commonRunQuery, loansCreateBankCode, loansUpdateBankCode } from "../../../util/API/loans";
import LoanSetupTable from "../../../components/LoanSetupTable/LoanSetupTable";
import CustomLoansForm from "../../../components/UI/CustomLoansForm/CustomLoansForm";

const LoanBankCodes = ({ setAlert, setAlertOpen }) => {
    const [viewMode, setViewMode] = useState("table");
    const [bankCodes, setBankCodes] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);

    const columns = [
        {
            label: 'ID',
            getValue: (row) => row?.loanbankcodes?.id ?? ''
        },
        {
            label: 'Bank/FI Code',
            getValue: (row) => row?.loanbankcodes?.bankcode ?? ''
        },
        {
            label: 'Bank/FI Name',
            getValue: (row) => row?.loanbankcodes?.bankname ?? ''
        }
    ]

    useEffect(()=> {
        getAllLoanBankCodes();
    }, []);

    const getAllLoanBankCodes = async () => {
        try {
            let response = await commonRunQuery(279, "");
            if (
                response?.data?.header?.callStatus === "1" &&
                response?.data?.header?.reccount !== "0"
            ) {
                const bankCodesArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
    
                setBankCodes(bankCodesArray);
                console.log("bankCodesArray=======================", bankCodesArray);
            } else {
                setBankCodes([]);
            }
        } catch (error) {
            console.log("getAllLoanCurrMessages_error=======================", error);
        }
    };

    const handleEdit = (rowData) => {
        console.log("handleEdit_rowData=======================", rowData);
        setSelectedRowData(rowData);
        setViewMode("edit")
    }

    const handleSubmit = async(submittedValue) => {
        console.log("handleSubmit_submittedValue=======================", submittedValue);
        try {
            const response = await loansCreateBankCode(
                "",
                submittedValue?.bankcode,
                submittedValue?.bankname
            );

            console.log("handleSubmit_response----------------", response)
            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Loan bank code created successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                getAllLoanBankCodes();
                setViewMode("table");
            } else if(response?.Status == '2' && response?.payload?.callStatus == "0") {
                setAlert({
                    showAlert: true,
                    message: response?.payload?.msg,
                    severity: "error",
                    header: "Error",
                });
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in creating loan bank code. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const handleUpdate = async(submittedValue) => {
        console.log("handleUpdate_submittedValue=======================", submittedValue);
        try {
            const response = await loansUpdateBankCode(
                "",
                submittedValue?.id,
                submittedValue?.bankcode,
                submittedValue?.bankname,
            );

            console.log("handleUpdate_response----------------", response)
            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Loan bank code updated successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);
                
                getAllLoanBankCodes();
                setViewMode("table");
            } else if(response?.Status == '2' && response?.payload?.callStatus == "0") {
                setAlert({
                    showAlert: true,
                    message: response?.payload?.msg,
                    severity: "error",
                    header: "Error",
                });
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in updating loan bank code. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const formatedRows = (row) => columns.map((column) => column.getValue(row));

    return (
        <Box sx={{ p: 2 }} className="loan-curr-msg-container">
            {viewMode === "table" && (
                <Box>
                    <Box className="d-flex justify-content-between align-items-center mb-2">
                        <Typography variant="h6">
                            Loan Bank Codes
                        </Typography>
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setViewMode("create");
                            }}
                        >
                            Create Loan Bank Codes
                        </Button>
                    </Box>

                    <LoanSetupTable
                        data={bankCodes}
                        columns={columns}
                        title="Loan Product Message"
                        formatRow = {formatedRows}
                        isEdit={true}
                        handleEdit={handleEdit}
                    />
                </Box>
            )}

            {(viewMode === "create" || viewMode === "edit")  && (
                <Box>
                    <Box className="d-flex justify-content-between align-items-center mb-2">
                        <Typography variant="h6">
                            
                        </Typography>
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setViewMode("table");
                                setSelectedRowData(null);
                            }}
                        >
                            Return
                        </Button>
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, maxWidth: 800, mt: 2 }}>
                        <CustomLoansForm
                            formValues={null}
                            formName={"createloanbankcodes"}
                            buttonText={viewMode === "edit" ? "Update" : "Submit"}
                            loadingButtonText={viewMode === "edit" ? "Updating Bank Codes ..." : "Creating Bank Codes ..."}
                            onSubmit={viewMode === "create" ? handleSubmit : handleUpdate}
                            initialValues={{
                                bankcode:selectedRowData?.loanbankcodes?.bankcode,
                                bankname:selectedRowData?.loanbankcodes?.bankname,
                                id:selectedRowData?.loanbankcodes?.id
                            }}
                            isEdit={viewMode == "edit" ? true : false}
                            isCreate={viewMode == "create" ? true : false}
                        />
                    </Box>
                </Box>
            )}
        </Box>
    )
}

export default LoanBankCodes;